import type { ValidationFunction } from '../types';

export const textLengthLessThanOrEqualTo =
  (length: number): ValidationFunction<string | null | undefined> =>
  (value?: string | null) => {
    return value != null ? value.length <= length : true;
  };
